import gql from 'graphql-tag';
import { servicePackageFragment } from '@/graphql-fragments';

export const GET_SERVICE_PACKAGES = gql`
  query getServicePackages {
    servicePackages {
      ...servicePackage
    }
  }
  ${servicePackageFragment}
`;

export const GET_SERVICE_PACKAGE = gql`
  query getServicePackage($id: Int!) {
    servicePackage(id: $id) {
      ...servicePackage
    }
  }
  ${servicePackageFragment}
`;

export const CREATE_SERVICE_PACKAGE = gql`
  mutation createServicePackage($input: CreateServicePackageInput!) {
    createServicePackage(input: $input) {
      servicePackage {
        ...servicePackage
      }
      errors
    }
  }
  ${servicePackageFragment}
`;

export const UPDATE_SERVICE_PACKAGE = gql`
  mutation updateServicePackage($input: UpdateServicePackageInput!) {
    updateServicePackage(input: $input) {
      servicePackage {
        ...servicePackage
      }
      errors
    }
  }
  ${servicePackageFragment}
`;

export const DELETE_SERVICE_PACKAGE = gql`
  mutation deleteServicePackage($input: DeleteServicePackageInput!) {
    deleteServicePackage(input: $input) {
      status
    }
  }
`;

export const SORT_SERVICE_PACKAGES = gql`
  mutation sortServicePackages($input: SortServicePackagesInput!) {
    sortServicePackages(input: $input) {
      servicePackages {
        id
        sortOrder
      }
    }
  }
`;
